module.exports = require('./lib/_stream_duplex.js');



// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/duplex-browser.js